import React from 'react';
import {
	AvatarName,
	VStack,
	Text,
} from '@montel/montelpro-shared-components-v2';
import { StyledProfileButton } from './styles';
import { useAuth } from '@montel/montelpro-auth';
import { getAdminRoleNameFromValue } from 'domain/account/enums';

interface ProfileButtonProps {
	onClick: () => void;
}

const ProfileButton: React.FC<ProfileButtonProps> = ({ onClick }) => {
	const { user } = useAuth();
	const usersName = `${user?.firstName} ${user?.lastName}`;

	return (
		<StyledProfileButton onClick={() => onClick()} align="center">
			<VStack align="flex-end" gap="xxs">
				<Text>{usersName}</Text>
				<Text weight="600" size="xs">
					{user?.roles
						?.map((r: any) => getAdminRoleNameFromValue(r))
						.join(', ') ?? 'N/A'}
				</Text>
			</VStack>
			<AvatarName name={usersName} size="xl" backgroundColor="white" />
		</StyledProfileButton>
	);
};

export default ProfileButton;
